export default __webpack_public_path__ + "static/_DSC8422_370x780-b4bf08456fc5489837a82393da5d41f6.png";